import { FC } from 'react';
import * as React from 'react';
import styled from '@emotion/styled';
import {
    PropertyWrapper,
    StyledFeaturePropertiesHeader,
    StyledBadge
} from './FeaturedProperties.styles';
import { FeaturedPropertyData } from './FeaturedProperties.types';
import FeaturedPropertyCard from './FeaturedPropertyCard';
import {
    internalPromos,
    InternalPromoId,
    internalPromoIds
} from './InternalPromoCard/internalPromoData';
import InternalPromoCard from './InternalPromoCard';

export type InternalPromo = {
    type: 'Internal Promo';
    id: InternalPromoId;
    onClick?: () => void;
};

export type FeaturedProperty = {
    type: 'Featured Property';
    data: FeaturedPropertyData;
    onClick?: () => void;
};

export type FeaturedItem = FeaturedProperty | InternalPromo;

export type Props = {
    featuredItems: FeaturedItem[];
    sectionType: 'sale' | 'rent';
    searchParam?: string;
} & React.HTMLProps<HTMLDivElement>;

const FeaturedPropertiesComponent: FC<Props> = ({
    featuredItems,
    sectionType,
    searchParam
}) => {
    const currentSection = sectionType === 'sale' ? 'for-sale' : 'to-rent';

    return featuredItems.length > 0 ? (
        <PropertyWrapper data-testid="featured-listings">
            <StyledFeaturePropertiesHeader data-testid="featured-properties-badge">
                <StyledBadge variant="featured" />
            </StyledFeaturePropertiesHeader>
            {featuredItems.map((item) =>
                item.type === 'Featured Property' ? (
                    <FeaturedPropertyCard
                        property={item.data}
                        key={item.data.listingId}
                        onClick={item.onClick}
                    />
                ) : (
                    <InternalPromoCard
                        promo={internalPromos[item.id]}
                        key={item.id}
                        currentSection={currentSection}
                        searchParam={searchParam}
                        onClick={item.onClick}
                    />
                )
            )}
        </PropertyWrapper>
    ) : null;
};

/**
 * - This component is displayed on the Search Results Page, the component is used to display 1 weekly featured listing and 2 featured listings.
 * - We do not display this component on Mobile devices / sizes. ([Decision log](https://zpgltd.atlassian.net/wiki/spaces/PT/pages/2044231693/Featured+Properties+Availability+on+mobile))
 *
| **Team**               |       |
| -----------------------|--------------|
| **Zeroheight**         |   https://zeroheight.com/8f6f2b33a/v/latest/p/07d92d-listing-cards/b/346990      |
**/
const FeaturedProperties = styled(FeaturedPropertiesComponent)();

export { internalPromoIds };
export default FeaturedProperties;
